import { Button, Dropdown, MenuProps, Row } from "antd";
import { useCallback, useMemo } from "react";
import { MoreOutlined } from "@ant-design/icons";
import { useExportExcel } from "../../../../../../lib/hooks/exportExcel";
import IncidentReportsService from "../../../../../../services/incidentReports";
import { usePermissions } from "../../../../../../lib/hooks/usePermissions";

type HeaderProps = {
  id: string;
  type: 1 | 2;
  setItem: React.Dispatch<React.SetStateAction<string | null | undefined>>;
};

export const Header = ({ id, type, setItem }: HeaderProps) => {
  const { hasAccessByController } = usePermissions("Export");

  const exportRequest = useMemo(() => {
    return type === 1 ? { contractId: id } : { customerId: id };
  }, [id, type]);

  const { onExportExcelButtonClicked, isLoading } = useExportExcel(
    IncidentReportsService,
    exportRequest,
    "incidents.xlsx",
  );

  const moreActions: MenuProps["items"] = useMemo(
    () => [
      {
        key: "1",
        label: <Row onClick={onExportExcelButtonClicked}>Export All</Row>,
      },
    ],
    [onExportExcelButtonClicked],
  );

  const onAdd = useCallback(() => setItem(null), [setItem]);

  return (
    <Row className="d-block w-100">
      <Row className="w-100 justify-space-between customer-info-card align-center card-header">
        <h5 className="h h5">Incidents</h5>
        <Row>
          <Button shape="round" className="mr-4" onClick={onAdd}>
            Add New
          </Button>
          {hasAccessByController("IncidentReports") && (
            <Dropdown
              menu={{ items: moreActions }}
              trigger={["click"]}
              disabled={isLoading}
            >
              <Button icon={<MoreOutlined />} shape="circle" />
            </Dropdown>
          )}
        </Row>
      </Row>
    </Row>
  );
};
